import { ClaimInvoice } from '../../lib/interfaces/ClaimInvoice.interface'

import {
  ActionTypes,
  actionTypes,
  InvoicePaySuccessAction,
  InvoiceFetchSuccessAction,
  InvoiceFetchFilesErrorAction,
  InvoiceFetchFilesSuccessAction,
  InvoicesFetchListSuccessAction,
  InvoiceAddTrackingSuccessAction
} from './actions'

const get = require('lodash/get')
const findIndex = require('lodash/findIndex')

export interface InvoicesState {
  readonly invoices?: [ClaimInvoice]
  readonly isDeleting: boolean
  readonly isFetching: boolean
  readonly fetchFilesError?: any
  readonly isFetchingFiles: boolean
  readonly isUploadingFile: boolean
  readonly invoiceDetails?: ClaimInvoice
}

export const initialState: InvoicesState = {
  isDeleting: false,
  isFetching: false,
  invoices: undefined,
  isFetchingFiles: false,
  isUploadingFile: false,
  invoiceDetails: undefined,
  fetchFilesError: undefined
}

export function reducer(state: InvoicesState = initialState, action: ActionTypes): InvoicesState {
  switch (action.type) {
    case actionTypes.INVOICES_FETCH_LIST:
      return {
        ...state,
        invoices: initialState.invoices,
        isFetching: true
      }

    case actionTypes.INVOICES_FETCH_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        invoices: (action as InvoicesFetchListSuccessAction).payload.invoices
      }

    case actionTypes.INVOICES_FETCH_LIST_FAILED:
      return {
        ...state,
        isFetching: false
      }

    case actionTypes.INVOICE_FETCH:
      return {
        ...state,
        isFetching: true,
        invoiceDetails: undefined
      }

    case actionTypes.INVOICE_FETCH_FAILED:
      return {
        ...state,
        isFetching: false,
        invoiceDetails: undefined
      }

    case actionTypes.INVOICE_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        invoiceDetails: (action as InvoiceFetchSuccessAction).payload.invoice
      }

    case actionTypes.INVOICES_UPLOAD_FILE:
      return { ...state, isUploadingFile: true }

    case actionTypes.INVOICES_UPLOAD_FILE_SUCCESS:
      return { ...state, isUploadingFile: false }

    case actionTypes.INVOICES_UPLOAD_FILE_FAILED:
      return { ...state, isUploadingFile: false }

      case actionTypes.INVOICES_FETCH_FILES:
      return {
        ...state,
        isFetchingFiles: true,
        fetchFilesError: undefined
      }

    case actionTypes.INVOICES_FETCH_FILES_FAILED: {
      const invoiceFilesErrorAction = action as InvoiceFetchFilesErrorAction

      return {
        ...state,
        isFetchingFiles: false,
        fetchFilesError: invoiceFilesErrorAction.payload.errorMessage
      }
    }

    case actionTypes.INVOICES_FETCH_FILES_SUCCESS: {
      const invoiceFilesAction = action as InvoiceFetchFilesSuccessAction

      const files = invoiceFilesAction.payload.files
      const invoiceId = invoiceFilesAction.payload.invoiceId

      const invoices: ClaimInvoice[] = [ ...get(state, 'invoices', []) ]
      const invoiceIndex = findIndex(invoices, { id: invoiceId })

      if (invoiceIndex >= 0) {
        const invoice = invoices[invoiceIndex]
        invoice.files = files
        invoices.splice(invoiceIndex, 1, invoice)
      }

      const newState = { ...state, isFetchingFiles: false }

      if (state.invoiceDetails && state.invoiceDetails.id === invoiceId) {
        const invoiceDetails = { ...state.invoiceDetails } as ClaimInvoice

        invoiceDetails.files = files
        newState.invoiceDetails = invoiceDetails
      }

      newState.fetchFilesError = undefined

      return newState
    }

    case actionTypes.INVOICES_PAY_SUCCESS: {
      const invoicePaySuccessAction = action as InvoicePaySuccessAction

      const { invoice } = invoicePaySuccessAction.payload
      if (state.invoiceDetails && state.invoiceDetails.id === invoice.id) {
        return {
          ...state,
          invoiceDetails: invoice
        }
      }

      
      return state
    }
    
    case actionTypes.INVOICES_DELETE:
      return { ...state, isDeleting: true }

    case actionTypes.INVOICES_DELETE_FAILED:
      return { ...state, isDeleting: false }

    case actionTypes.INVOICES_DELETE_SUCCESS:
      return { ...state, isDeleting: false }

    case actionTypes.INVOICES_ADD_TRACKING_SUCESS:
      const invoiceAddTrackingAction = action as InvoiceAddTrackingSuccessAction      
      return {...state, invoiceDetails: invoiceAddTrackingAction.payload.invoice}      
      
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/invoices/reducer.ts